import FilesPedidosClient from '@/api/Operacoes/files.client';
import Store from '@/store';
import { ErrorMessage } from '@/libs/Error';
import Notifier from '@/libs/Notifier';

export default class FilesService {
  constructor() {
    this.client = new FilesPedidosClient();
    this.notify = new Notifier();
    this.vuex = Store;
  }

  async indexFiles(pedidoId) {
    try {
      this.vuex.commit('filesStore/SET_IS_LOADING', true);
      const response = await this.client.gerarPdfPedidos(pedidoId);
      const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

      this.vuex.commit('filesStore/SET_GENERATED_LABEL_URL', url);
      this.notify.success('PDF gerado com sucesso', 'Sucesso');
    } catch (error) {
      console.error(error, 'Erro ao gerar PDF do pedido');
    } finally {
      this.vuex.commit('filesStore/SET_IS_LOADING', false);
    }
  }
}
